import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';
import AdminHeader from '../../../components/header/AdminHeader';
import {
  licenseAdd,
  licenseDecode,
  licenseGet,
  licenseUpdate
} from '../../../store/slices/adminSlices/adminDashboardSlice';
import FormTextarea from '../../../components/form/FormTextarea';
import { toast } from 'react-toastify';

const AdminDashboard = () => {
  const dispatch = useDispatch();

  const [licenseKey, setLicenseKey] = useState(null);
  const [licenseId, setLicenseId] = useState(null);
  const [newLicenseKey, setNewLicenseKey] = useState('');
  const [licenseDetails, setLicenseDetails] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const fetchLicense = async () => {
    try {
      const response = await dispatch(licenseGet()).unwrap();
      if (response?.success && response?.data?.length > 0) {
        const license = response.data[0];
        setLicenseKey(license?.license_key);
        setLicenseId(license?.id);
      }
    } catch (error) {
      console.error('Error fetching license:', error);
    }
  };

  const decodeLicense = async () => {
    try {
      const response = await dispatch(licenseDecode()).unwrap();
      if (response?.success) {
        setLicenseDetails(response?.data);
      }
    } catch (error) {
      console.error('Error decoding license:', error);
      setLicenseDetails(null);
    }
  };

  const saveLicense = async () => {
    if (!newLicenseKey) return;

    try {
      const payload = { license_key: newLicenseKey, id: isEdit ? licenseId : undefined };
      const action = isEdit ? licenseUpdate(payload) : licenseAdd(payload);
      const response = await dispatch(action).unwrap();

      if (response?.success) {
        toast.success(response.message);
        resetForm();
        fetchLicense();
        decodeLicense();
      }
    } catch (error) {
      console.error('Error saving license:', error);
    }
  };

  const resetForm = () => {
    setIsEdit(false);
    setNewLicenseKey('');
  };

  useEffect(() => {
    fetchLicense();
    decodeLicense();
  }, []);

  return (
    <div>
      <AdminHeader title="Dashboard" />
      <Card className="p-4">
        <span className="fs-5 mb-2 text-primary fw-bolder">License Key</span>
        {licenseKey && !isEdit ? (
          <div>
            <span className="text-primary fw-medium">{licenseKey}</span>
            <span
              className="text-info ms-3 cursor-pointer"
              onClick={() => {
                setIsEdit(true);
                setNewLicenseKey(licenseKey);
              }}>
              <Icon.Edit size={18} />
            </span>
          </div>
        ) : (
          <Row>
            <Col lg="12">
              <FormTextarea
                name="newLicenseKey"
                isShowLabel={false}
                placeholder="Enter License Key"
                value={newLicenseKey}
                onChange={(e) => setNewLicenseKey(e.target.value)}
              />
            </Col>
            <Col lg="12">
              <div className="d-flex justify-content-end align-items-center gap-3">
                <Button onClick={resetForm} className="px-5 bg-transparent text-primary">
                  Cancel
                </Button>
                <Button
                  onClick={saveLicense}
                  disabled={!newLicenseKey}
                  className="px-5 bg-primary border-primary">
                  {isEdit ? 'Update' : 'Add'}
                </Button>
              </div>
            </Col>
          </Row>
        )}
      </Card>

      {licenseDetails && (
        <Card className="p-4">
          <span className="fs-5 mb-2 text-primary fw-bolder">License Details</span>
          <div>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Expiry Date</th>
                  <th>Ip Address</th>
                  <th>Permitted User</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{licenseDetails?.company_name || '-'}</td>
                  <td>{licenseDetails?.expiry_date || '-'}</td>
                  <td>{licenseDetails?.ip_address || '-'}</td>
                  <td>{licenseDetails?.permitted_user || '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
};

export default AdminDashboard;
